import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// feature toll charges
import * as A from './actions';
//////////////////////////////////////////////////

const initialState = {
  itemList: {},
  totalCount: 0,
  loading: false,
  usedReport: {},
  truckGuid: null,
  titleSortValues: {},
  reportPending: false,
  tableTitleFilters: {},
  additionalFilters: {},
  pagination: {
    limit: 20,
    offset: 0,
  },
};

const setInitialState = () => initialState;

const setTruckGuid = (state, truckGuid) => P.$set('truckGuid', truckGuid, state);

const toggleIftaReportDetails = (state, data) => (
  P.$toggle(`itemList.${data.guid}.expanded`, state)
);

const setListLoading = (state, data) => (
  P.$set('loading', data, state)
);

const getIftaListSuccess = (state, data) => {
  const { itemList, pagination } = state;
  const { results, totalCount } = data;

  const mappedList = R.compose(
    R.indexBy(R.prop(GC.FIELD_GUID)),
    G.mapIndexed((item, index) => R.mergeRight(
      item,
      {
        index,
        expanded: false,
        [GC.SYSTEM_LIST_TELS]: [],
        activeTab: GC.FIELD_IFTA_TRUCKS,
        [GC.SYSTEM_LIST_FUEL_TRANSACTIONS]: [],
      },
    )),
  )(results);
  const newList = R.mergeRight(itemList, mappedList);
  const newOffset = R.sum(R.values(pagination));
  const offset = G.ifElse(R.gt(data.totalCount, pagination.offset), newOffset, totalCount);

  return P.$all(
    P.$set('itemList', newList),
    P.$set('totalCount', totalCount),
    P.$set('pagination.offset', offset),
    state,
  );
};

const setAdditionalFilters = (state, filters) => (
  P.$set('additionalFilters', filters, state)
);

const setUsedReport = (state, data) => (
  P.$all(
    P.$set('itemList', null),
    P.$set('usedReport', data),
    P.$set('reportPending', false),
    P.$set('pagination', initialState.pagination),
    state,
  )
);

const setReportPending = (state) => (
  P.$set('reportPending', true, state)
);

const setReports = (state, data) => (
  P.$set('availableReports', data, state)
);

const removeIFTASuccess = (state, guid) => (
  P.$drop(`itemList.${guid}`, state)
);

const resetListAndPagination = (state) => (
  P.$all(
    P.$set('itemList', {}),
    P.$set('totalCount', 0),
    P.$set('pagination', initialState.pagination),
    state,
  )
);

const changeActiveTabSuccess = (state, { guid, list, tabName }) => (
  P.$set(
    `itemList.${guid}`,
    R.mergeRight(
      R.path(['itemList', guid], state),
      { [tabName]: list, activeTab: tabName },
    ),
    state,
  )
);

export default createReducer({
  [A.setReports]: setReports,
  [A.setTruckGuid]: setTruckGuid,
  [A.setUsedReport]: setUsedReport,
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setReportPending]: setReportPending,
  [A.removeIFTASuccess]: removeIFTASuccess,
  [A.setTableTitleSort]: G.setTableTitleSort,
  [A.getIftaListSuccess]: getIftaListSuccess,
  [A.setTableTitleFilter]: G.setTableTitleFilter,
  [A.setAdditionalFilters]: setAdditionalFilters,
  [A.resetListAndPagination]: resetListAndPagination,
  [A.changeActiveTabSuccess]: changeActiveTabSuccess,
  [A.toggleIftaReportDetails]: toggleIftaReportDetails,
}, initialState);
